module.exports = __webpack_public_path__ + "kudos_83.svg?4429a9e26071e86af297ab56c0551185";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_83.svg
// module id = 187
// module chunks = 0